/** The ClubCore mark: an open ring (the "C") around a flag on the green. Colors follow the theme and club accent. */
export function BrandMark({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      <path d="M36 11.5A16.5 16.5 0 1 0 36 36.5" fill="none" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
      <path d="M25 34V14l9 4.2-9 4.2" fill="var(--cc-nav-accent)" stroke="var(--cc-nav-accent)" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M17 35c4-1 9-1 14-3" fill="none" stroke="var(--cc-nav-accent)" strokeWidth="2.4" strokeLinecap="round" />
    </svg>
  );
}
